document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.href;

  if (url.includes("car-seat-cover-transition-wrap") && url.includes("view=landing-page-ghl")) {

    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href");
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: "smooth"
          });
        }
      });
    });

  }

/* 2026-10-01 (audit item 5, CLS): the announcement markup is now rendered server-side in
   layout/theme.liquid (no more late injection / layout shift). This only wires the close button. */
  const announcement = document.getElementById("om-announcement");
  if (announcement) {
    const closeBtn = announcement.querySelector(".om-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        announcement.remove();
        sessionStorage.setItem("om_ann_dismissed", "1");
      });
    }
  }

});

/* --------------------------------------------------------------------
 * Cart attach offers - button handlers for snippets/om-kit-upsell.liquid
 * Added 26 Aug 2026. RESTORED 4 Sep 2026 (Claude), for Josh.
 *
 * THIS BLOCK WAS WIPED FROM THE LIVE THEME BETWEEN 2 AND 4 SEP.
 * custom.js on MAIN had fallen back to 2,276 bytes - the announcement
 * bar and the GHL landing-page scroll above, and none of this. Later
 * themes were duplicated from an OLDER base and published, reverting
 * this file, snippets/om-kit-upsell.liquid and the render call in
 * snippets/cart-subtotal.liquid together. The theme holding the only
 * other copy was then deleted.
 *
 * BEFORE PUBLISHING ANY THEME: duplicate from the CURRENT MAIN, and
 * confirm this file is ~7.8KB not ~2.3KB, that om-kit-upsell.liquid
 * exists, and that cart-subtotal.liquid still renders it.
 *
 * WHY THESE LIVE HERE AND NOT IN THE SNIPPET:
 * <cart-form> replaces its own innerHTML every time the cart changes.
 * A <script> tag inserted via innerHTML is never executed by the
 * browser, so the snippet's original inline script bound its listeners
 * once on first paint and went dead the moment the drawer re-rendered -
 * which is every single add-to-cart. Delegated listeners on document
 * survive every re-render. Do not move this code back into the snippet.
 *
 * NO DISCOUNT CODES (Josh, 26 Aug 2026): adds go straight into the
 * cart at full price and the drawer refreshes in place.
 *
 * Every add is tagged _om_upsell = kit-drawer, so attach rate stays
 * measurable from order line items.
 * ------------------------------------------------------------------ */
(function () {
  var PREFIX = 'om_dismiss_';
  var busy = false;

  function getFlag(key) {
    try { return sessionStorage.getItem(PREFIX + key); } catch (e) { return null; }
  }

  function setFlag(key) {
    try { sessionStorage.setItem(PREFIX + key, '1'); } catch (e) {}
  }

  function applyDismissed() {
    var boxes = document.querySelectorAll('[data-om-upsell]');
    for (var i = 0; i < boxes.length; i++) {
      if (getFlag(boxes[i].getAttribute('data-om-upsell'))) {
        boxes[i].style.display = 'none';
      }
    }
  }

  function addToCart(items, btn) {
    if (busy) return;
    busy = true;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    for (var i = 0; i < items.length; i++) {
      items[i].properties = { '_om_upsell': 'kit-drawer' };
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'om_kit_upsell_add_to_cart', currency: 'USD' });
        } catch (e) { /* tracking must never break add-to-cart */ }
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Could not add - try again';
        setTimeout(function () { btn.textContent = label; }, 4000);
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || target.nodeType !== 1 || !target.closest) return;

    var dismiss = target.closest('[data-om-dismiss]');
    if (dismiss) {
      e.preventDefault();
      var key = dismiss.getAttribute('data-om-dismiss');
      var box = dismiss.closest('[data-om-upsell]');
      if (box) box.style.display = 'none';
      setFlag(key);
      return;
    }

    var single = target.closest('[data-om-add]');
    if (single) {
      e.preventDefault();
      var scope = single.closest('[data-om-upsell]') || document;
      var sel = scope.querySelector('[data-om-variant]');
      if (!sel || !sel.value) return;
      addToCart([{ id: Number(sel.value), quantity: 1 }], single);
      return;
    }

    var pair = target.closest('[data-om-add-pair]');
    if (pair) {
      e.preventDefault();
      addToCart(
        [
          { id: Number(pair.getAttribute('data-om-v1')), quantity: 1 },
          { id: Number(pair.getAttribute('data-om-v2')), quantity: 1 }
        ],
        pair
      );
    }
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute('data-om-cart-extras') ||
              (n.querySelector && n.querySelector('[data-om-cart-extras]'))) {
            applyDismissed();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDismissed);
  } else {
    applyDismissed();
  }
})();
